import type { FlagConfiguration } from '@atlassian/jira-flags';
import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	title: {
		id: 'directories.filters-v2.main.flags.initiate-copy-modal.error.title',
		defaultMessage: "We couldn't get filter data",
		description:
			'Title of the flag shown in Filters Directory when the request for fetching data of a filter failed',
	},
	description: {
		id: 'directories.filters-v2.main.flags.initiate-copy-modal.error.description',
		defaultMessage: 'Something went wrong. Try again.',
		description:
			'Message shown in the flag displayed in Filters Directory when the request for fetching data of a filter failed',
	},
});

const initiateError = (): FlagConfiguration => ({
	type: 'error',
	title: messages.title,
	description: messages.description,
	messageId: 'filters-main.flags.initiate-copy-modal.flag.error',
	messageType: 'transactional',
});

export default initiateError;
